import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { BookOpen, ArrowLeft, Mail } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al enviar. Intenta de nuevo.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="text-center mb-8">
          <div className="w-10 h-10 rounded-sm bg-slate-dark flex items-center justify-center mx-auto mb-4">
            <BookOpen className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-serif font-bold text-slate-dark">Recuperar Contrasena</h1>
          <p className="text-sm font-sans text-gray-400 mt-1">Te enviaremos un enlace para restablecerla</p>
        </div>

        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-success">
            <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center mx-auto">
              <Mail className="w-6 h-6 text-green-600" />
            </div>
            <p className="text-sm font-sans text-gray-600">Si el email <strong>{email}</strong> esta registrado, recibiras un enlace para restablecer tu contrasena.</p>
            <p className="text-xs font-sans text-gray-400">Revisa tu bandeja de entrada y carpeta de spam.</p>
            <Link to="/login" className="text-sm font-sans text-trans-blue hover:underline font-medium inline-block mt-4">Volver al inicio de sesion</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
            {error && <div className="p-3 text-sm font-sans bg-red-50 text-red-600 rounded-md border border-red-100">{error}</div>}
            <div className="space-y-1.5">
              <Label htmlFor="email" className="font-sans text-sm">Email</Label>
              <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="tu@email.com" data-testid="forgot-email" className="font-sans" />
            </div>
            <Button type="submit" className="w-full bg-slate-dark hover:bg-slate-dark/90 font-sans" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? 'Enviando...' : 'Enviar enlace de recuperacion'}
            </Button>
          </form>
        )}

        <p className="text-center text-sm font-sans text-gray-400 mt-6">
          <Link to="/login" className="text-trans-blue hover:underline font-medium inline-flex items-center gap-1">
            <ArrowLeft className="w-3.5 h-3.5" /> Volver al inicio de sesion
          </Link>
        </p>
      </div>
    </div>
  );
}
